<template>
  <section class="contact-form">
    <LineText :title="currentLang === 'it' ? 'Contattaci' : 'Get in touch'"/>
    <main class="contact-form__container c-container c-container--small">
      <FormTemplate>
        <FormCore
          slot="core"
          data-theme="default"
          :slots="['row-0', 'row-1', 'row-2', 'row-3', 'row-4']"
        >
          <FormRow
            slot="row-0"
            :slots="['fname', 'lname']"
          >
            <FormInput
              slot="fname"
              :type="form.fname.type"
              :params="form.fname"
            />

            <FormInput
              slot="lname"
              :type="form.lname.type"
              :params="form.lname"
            />
          </FormRow>

          <FormRow
            slot="row-1"
            :slots="['email', 'company']"
          >
            <FormInput
              slot="email"
              :type="form.email.type"
              :params="form.email"
            />

            <FormInput
              slot="company"
              :type="form.company.type"
              :params="form.company"
            />
          </FormRow>

          <FormRow
            slot="row-2"
            :slots="['message']"
          >
            <FormInput
              slot="message"
              :type="form.message.type"
              :params="form.message"
            />
          </FormRow>

          <FormRow
            slot="row-3"
            :slots="['upload']"
          >
            <FormInput
              slot="upload"
              :type="form.upload.type"
              :params="form.upload"
            />
          </FormRow>

          <FormRow
            slot="row-4"
            :slots="['privacy', 'submit']"
          >

            <FormInput
              slot="privacy"
              :type="form.privacy.type"
              :params="form.privacy"
            />

            <FormInput
              slot="submit"
              :type="form.submit.type"
              :params="form.submit"
            />
          </FormRow>
        </FormCore>
      </FormTemplate>
    </main>
  </section>
</template>

<script>
import { mapState } from 'vuex';

import LineText from '@/components/LineText.vue';
import FormTemplate from './Form/index.vue';
import FormCore from './Form/FormCore/index.vue';
import FormRow from './Form/FormExtra/FormRow.vue';
import FormInput from './Form/FormInput/index.vue';

export default {
  name: 'Test',

  components: {
    LineText,
    FormTemplate,
    FormCore,
    FormRow,
    FormInput,
  },

  data() {
    return {
      form: {
        fname: {
          id: 'fname',
          name: 'fname',
          type: 'text',
          label: 'Name',
          autocomplete: 'given-name',
          size: 50,
        },
        lname: {
          id: 'lname',
          name: 'lname',
          type: 'text',
          label: 'Surname',
          autocomplete: 'family-name',
          size: 50,
        },
        email: {
          id: 'email',
          name: 'email',
          type: 'email',
          label: 'Email',
          autocomplete: 'email',
          size: 50,
        },
        company: {
          id: 'company',
          name: 'company',
          type: 'text',
          label: 'Company',
          autocomplete: 'org',
          size: 50,
        },
        message: {
          id: 'message',
          name: 'message',
          type: 'textarea',
          label: 'Message',
          cols: 30,
          rows: 4,
          size: 100,
        },
        upload: {
          id: 'upload',
          name: 'upload',
          type: 'file',
          label: 'File',
          size: 100,
        },
        privacy: {
          id: 'privacy',
          name: 'privacy',
          type: 'checkbox',
          choices: [{
            id: 'privacy',
            value: 'privacy',
            label: 'Accept <a href="#!"><bdi>privacy</bdi></a>',
          }],
        },
        submit: {
          id: 'submit',
          name: 'submit',
          type: 'submit',
          text: 'Contact us',
          sending: 'Sending',
          sent: 'Sent',
        },
      },
    };
  },

  computed: {
    ...mapState(['currentLang']),
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/fonts';

.contact-form::v-deep {
  .form__group--submit {
    background-color: $color-red;

    .form__input__text {
      padding: 20px;
      color: $color-white;
      font-family: $font-family-title;
      text-align: center;
    }

    .form__input__line {
      display: none;
    }

    .form__input--submit {
      padding: 0;
    }
  }

  input,
  textarea {
    background-color: transparent;
  }
}
</style>
